module.exports = __webpack_public_path__ + "img/39.7bfffda2.svg";